import { Checkbox, Input, Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "ui/components/Input/Field";
import SelectContatoUnidade from "ui/components/Input/SelectContatoUnidade";
import { TipoContatoEnum } from "core/features/auth/typings/user";
import { PessoaContato } from "core/features/unidades/typings/unidade";
import InputMask from "components/Input/InputMask";
import { isValidEmail } from "infra/helpers/isValidEmail";

interface FormAddContatoProps {
  control: Control<PessoaContato>;
  form: PessoaContato;
  setValue: UseFormSetValue<PessoaContato>;
  hideCobranca?: boolean;
}

function FormAddContato({
  control,
  form,
  setValue,
  hideCobranca,
}: FormAddContatoProps) {
  return (
    <>
      <Row gutter={16}>
        <Col sm={10}>
          <Field
            label="Tipo"
            control={control}
            name="tipoContatoId"
            render={({ field, isInvalid }) => (
              <SelectContatoUnidade
                isInvalid={isInvalid}
                {...field}
                onChange={(value) => {
                  field.onChange(value);
                  setValue("conteudo", "");
                }}
              />
            )}
          />
        </Col>

        <Col sm={14}>
          <Field
            label="Contato"
            control={control}
            name="conteudo"
            rules={{
              required: true,
              validate: () => {
                if (form.tipoContatoId === TipoContatoEnum.Email) {
                  return isValidEmail(form.conteudo) || "Email inválido";
                }

                return true;
              },
            }}
            render={({ field }) => {
              if (form.tipoContatoId === TipoContatoEnum.Email) {
                return (
                  <Input
                    type="email"
                    {...field}
                    placeholder="seuemail@email.com"
                  />
                );
              } else if (form.tipoContatoId === TipoContatoEnum.Telefone) {
                return (
                  <InputMask
                    {...field}
                    placeholder="(00) 0000-0000"
                    mask="(99) 9999-9999"
                  />
                );
              } else {
                return (
                  <InputMask
                    {...field}
                    placeholder="(00) 00000-0000"
                    mask="(99) 99999-9999"
                  />
                );
              }
            }}
          />
        </Col>
      </Row>
      {!hideCobranca && [TipoContatoEnum.Email, TipoContatoEnum.Celular].includes(form.tipoContatoId) ? (
        <Box as={Row} mt={2}>
          <Col>
            <Field
              control={control}
              name="receberCobranca"
              render={({ field }) => (
                <Checkbox
                  isChecked={!!field.value}
                  onChange={(value) => {
                    field.value = value;
                    field.onChange(field.value);
                  }}
                >
                  Receber cobrança {form.tipoContatoId === TipoContatoEnum.Celular ? "por whatsapp" : ""}
                </Checkbox>
              )}
            />
          </Col>
        </Box>
      ) : null}
    </>
  );
}

export default FormAddContato;
